import React from "react";
import {observer} from "mobx-react-lite";
import {useSitStores} from "../../../../stores";
import {SitUserSelect} from "../../../components/SitUserSelect";
import {sitFieldLabel} from "../../../sitLabels";

/**
 * People & roles map onto owner/responsible/approver (per the reuse decision):
 * owner = Líder CDL, responsible = Sponsor CDL, approver = Sponsor NExO.
 */
export const InitiativePeopleForm: React.FC = observer(() => {
    const {initiativeInstanceStore} = useSitStores();

    return (
        <div className="sit-grid">
            <SitUserSelect
                label={sitFieldLabel('owner')}
                placeholder="Select"
                disabled={initiativeInstanceStore.disabled}
                required
                value={initiativeInstanceStore.instance.owner}
                onChange={(_event, value) => { if (value !== null) initiativeInstanceStore.owner = value; }}/>
            <SitUserSelect
                label={sitFieldLabel('responsible')}
                placeholder="Select"
                disabled={initiativeInstanceStore.disabled}
                required
                value={initiativeInstanceStore.instance.responsible}
                onChange={(_event, value) => { if (value !== null) initiativeInstanceStore.responsible = value; }}/>
            <SitUserSelect
                label={sitFieldLabel('approver')}
                placeholder="Select"
                disabled={initiativeInstanceStore.disabled}
                required
                value={initiativeInstanceStore.instance.approver}
                onChange={(_event, value) => { if (value !== null) initiativeInstanceStore.approver = value; }}/>
        </div>
    );
});
